module.exports = __webpack_public_path__ + "static/media/ips-registration.9f805027.svg";